import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/AddCircle';

const styles = {
  button: {
    margin: '5px 5px',
    paddingLeft: '40px',
    paddingRight: '40px',
    width: '96%'
  },
  leftIcon: {
    padding: '0px 5px',
    width: 32,
    height: 32,
    color: '#fff'
  }
};

const enhance = compose();

const button = enhance(
  ({ classes, id, onClickAction, btnText = 'メニュー追加' }) => {
    return (
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          onClickAction(id);
        }}
        className={classes.button}
      >
        <AddIcon className={classes.leftIcon} />
        {btnText}
      </Button>
    );
  }
);

export default withRouter(withStyles(styles)(button));
